const intro = `
    Hi, I’m Yash! I’m a Solutions Architect with a passion for designing and building scalable solutions. 
    I enjoy solving complex technical challenges and helping teams make the most of modern tech.
    Beyond work, you’ll find me exploring national parks, playing chess and puzzle games like Squaredle, riding my bike, or golfing.
    Check out some of my hobby projects below!
`
const bulletin = `
Bulletin is a browser alternative that delivers a desktop OS style UX for web apps. 
I created this because I was frustrated with always having 50+ tabs open, multiple Chrome windows, multiple tab groups, and yet still not knowing where anything is.
I wanted to solve this problem, and the most intuitive way to do it was to group tabs by web app, exactly like how a desktop OS does it.
`
const checkmate = `
Check Mate is a lightweight todo list and notetaking app designed to be stupid simple.
I found that all notetaking / todo list apps on the market have too many bells and whistles which makes it hard to quickly jot stuff down.
So I made Check Mate to accomplish just that. Most operations in it are a single click, it supports rich text in notes, and you don't need to create an account to get started.
It's actually a fully client side app so nothing even leaves your browser, besides anonymous analytics.
`

const descriptions = {
    intro,
    bulletin,
    checkmate,
}

export default descriptions;